import { useAuth } from '@/hooks/useAuth';
import { NutzerChip } from '@/components/ui/NutzerChip';
import { userLabel } from '@/lib/format';

/**
 * „Erfasst von …" mit dem Identitäts-Chip (A9.1).
 *
 * WARUM AN DEN SCHREIBSTELLEN UND NICHT NUR OBEN RECHTS
 *   Oben rechts steht, WER angemeldet ist. Das liest niemand, während er
 *   tippt. Am Tresen sitzt der Fehler aber genau dort: Kollegin A ist
 *   noch angemeldet, Kollege B nimmt den Anruf entgegen und schreibt
 *   den Eintrag — unter ihrem Namen, append-only, nicht mehr zu
 *   berichtigen.
 *
 *   Deshalb steht die Identität dort, wo geschrieben wird: im Kopf des
 *   Erfassungs-Formulars, über der Kommunikations-Eingabe und am
 *   Wareneingang. Nicht als Warnung — als Beiläufigkeit, die stimmt oder
 *   eben nicht.
 */
type Props = {
  /** „Erfasst von" · „Eintrag von" · „Gebucht von" — je nach Stelle. */
  text?: string;
  className?: string;
};

export function SchreibtAls({ text = 'Erfasst von', className }: Props) {
  const auth = useAuth();
  const me = auth.data?.user ?? null;
  if (me === null) return null;

  return (
    <div className={className}>
      <span className="inline-flex items-center gap-2 text-xs text-ink-soft">
        <NutzerChip
          farbe={me.farbe}
          symbol={me.symbol}
          kuerzel={me.kuerzel}
          name={userLabel(me)}
        />
        <span>
          {text} <span className="font-medium text-ink">{userLabel(me)}</span>
        </span>
      </span>
    </div>
  );
}
